import type { ReactElement } from 'react';
import { ApiKeys } from './ApiKeys.tsx';
import { Audit } from './Audit.tsx';
import { Themes } from './Themes.tsx';
import { Users } from './Users.tsx';

export const TENANCY_SHORTCUTS: [string, string][] = [
  ['g then h / u / k / a', 'Go to Themes, People, API keys, Audit log'],
  ['1 / 2 / 3', 'Site drawer: Settings, Addresses, Placements'],
];

export function tenancyPage(path: string): ReactElement | null {
  if (path === '/themes') return <Themes />;
  if (path === '/users') return <Users />;
  if (path === '/api-keys') return <ApiKeys />;
  if (path === '/audit') return <Audit />;
  return null;
}
